import { useState, useEffect } from 'react';
import inventoryService from '../../../services/inventoryService';

export const useInventoryStats = () => {
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const loadStats = async () => {
        try {
            setLoading(true);
            const statsData = await inventoryService.getInventoryStats();
            setStats(statsData);
            setError('');
        } catch (err) {
            setError(err.error || 'Failed to load inventory stats');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadStats();
    }, []);

    return {
        stats,
        loading,
        error,
        setError,
        loadStats
    };
};